import { render, staticRenderFns } from "./CadastroTemplateWhatsapp.vue?vue&type=template&id=ec259702&scoped=true&"
import script from "./CadastroTemplateWhatsapp.vue?vue&type=script&lang=js&"
export * from "./CadastroTemplateWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./CadastroTemplateWhatsapp.vue?vue&type=style&index=0&id=ec259702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec259702",
  null
  
)

export default component.exports